import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { ConfigProvider } from "antd";
import locale from "antd/es/locale/zh_CN";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import Store from "./redux/store";
import withTracker from './withTracker';


ReactDOM.render(
  // <React.StrictMode>
    <Provider store={Store}>
       {/* getPopupContainer={trigger => trigger?.parentNode as HTMLElement || document.body} */}
      <ConfigProvider locale={locale}>
        <BrowserRouter>
          <Switch>
            <Route path="*" component={withTracker(App,{})}></Route>
          </Switch>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
